import React from "react";

const Sounds = () => {
    return (
        <div id="Sounds">
            <h3>Sounds</h3>

            <p>
                Sound blocks allow you to play musical notes or audio clips in your app. These blocks are useful for adding audio cues, music, or sound effects.
            </p>

            <div className="imageContainer">
                <img src="/images/Sounds.png" alt="Sounds" />
            </div>

            <h4>Play Note Block</h4>
            <p>
                This block lets you play a musical note from <strong>C4 to B4</strong>. You can choose:
            </p>
            <ul>
                <li> <b>Note</b> C4 to B4.</li>
                <li> <b>Duration</b> 1/16 to 2 seconds.</li>
                <li> <b>Volume</b> from 0% to 100%.</li>
            </ul>
            <p>
                You can also execute blocks after the sound finishes by nesting them inside.
            </p>

            <h4>Play Sound Block</h4>
            <p>
                This block allows you to play a <strong>predefined sound</strong> or a <strong>custom sound</strong> that you've uploaded. You can:
            </p>
            <ul>
                <li><b>Select</b> a sound from the dropdown.</li>
                <li>Set the <b>volume</b> level (0% to 100%).</li>
                <li>Attach actions to run when the sound finishes.</li>
            </ul>

        </div>
    );
};

export default Sounds;
